import { API_URL } from './../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showErrorMessage
} from './../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    showErrorMessage,
    extractDataFromObject,
    API_URL,
};

export const GET_MAINTENANCE_LEVELS_LIST_API = `${API_URL}/api/MasterMaintenanceLevels/GetMasterMaintenanceLevels`;
export const POST_MAINTENANCE_LEVELS_API = `${API_URL}/api/MasterMaintenanceLevels/SaveMasterMaintenanceLevel`;
export const GET_MAINTENANCE_LEVELS_DETAILS_API = `${API_URL}/api/MasterMaintenanceLevels/GetMasterMaintenanceLevelById`;
export const DELETE_MAINTENANCE_LEVELS_API = `${API_URL}/api/MasterMaintenanceLevels/DeleteMasterMaintenanceLevel`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;

export const MaintenanceLevelsActionTypes = {
  get_master_data: createRequestActionTypes('GET_MAINTENANCE_LEVELS_MASTER_DATA'),
  get_maintenanceLevelsList: createRequestActionTypes('GET_MAINTENANCELEVELSLIST'),
  post_maintenanceLevels: createRequestActionTypes('POST_MAINTENANCELEVELS'),
  get_maintenanceLevelsDetails: createRequestActionTypes('GET_MAINTENANCELEVELSDETAILS'),
  delete_maintenanceLevels: createRequestActionTypes('DELETE_MAINTENANCELEVELS'),
};

export const MODULE = 'DCMASTER_MAINTENANCELEVELS';





// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/maintenanceLevel/constants/ApiConstants.js